import { useTranslation } from "react-i18next";
import { Link } from 'react-router-dom';

import { commafy } from "../../../utils/methods";

const ListTable = ({ title, pageNumber, pageCounter, totalCount, data, moreLink=null, tableSm=false }) => {
	const { t } = useTranslation();
	
	let startNumber = (pageNumber - 1) * pageCounter + 1;
	let endNumber = (startNumber + pageCounter - 1) < totalCount ? (startNumber + pageCounter - 1) : totalCount;

	return <>
		<div className="card mb-3">
			<div className="card-header">
				<div className="row flex-between-end">
					<div className="col-auto align-self-center">
						<p className="mb-0 mt-2">{title}</p>
					</div>
					<div className="col-auto ms-auto">
						{totalCount ?
							<small>{startNumber} {t('to')} {endNumber} {t('from')} {commafy(totalCount)}</small>
							:
							<small>{t('no_results')}</small>
						}
					</div>
				</div>
			</div>
			<div className="card-body pt-0">
				<div id="tableExample2">
					<div className="table-responsive scrollbar">
						<table className={"table table-bordered " + (tableSm ? 'table-sm' : '') + " table-hover table-striped fs--1 mb-0"}>
							<thead className="bg-200 text-900">
								<tr>
									{data.head.map(column =>
										<th key={column}>{column}</th>
									)}
								</tr>
							</thead>
							<tbody className="list">
								{data.body.length ?
									data.body.map((row, i) =>
										<tr key={i}>
											{row.map((column, j) => <td className={data.directions[j]} key={j}>{column}</td>)}
										</tr>
									) :
									<tr>
										<td className="text-center" colSpan={data.head.length}>{t('no_results')}</td>
									</tr>
								}
							</tbody>
						</table>
					</div>
				</div>
				{moreLink ?
					<div className="text-center">
						<Link className="btn btn-link btn-sm mt-2" to={moreLink}>{t('visit_all')}</Link>
					</div>
				: ''}
			</div>
		</div>
	</>
};

export default ListTable;
